import {vsprintf} from 'sprintf-js'

export function stringFormatSetup(){
    if (!String.format) {
        String.format = function(format) {
            const args = Array.prototype.slice.call(arguments, 1);
            return vsprintf(format, args);
        };
    }
}